var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Published-container"},[_c('DataTable',{attrs:{"type":_vm.Role,"title":_vm.Title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }